import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'app/common/helper';
import { Constant } from 'app/config/constants';
import { CommonTable } from 'app/model/entity/commonTable';
import { CommonTableService } from 'app/service/common-table.service';
import { DialogService } from 'app/service/dialog.service';

@Component({
  selector: 'dialog-page-switching-timing',
  templateUrl: './dialog-page-switching-timing.component.html',
  styleUrls: ['./dialog-page-switching-timing.component.scss']
})
export class DialogPageSwitchingTimingComponent implements OnInit {
  /**
   * commonTable
   */
  commonTable: CommonTable;
  /**
   * constant
   */
  Constant = Constant;

  /**
   * timetable Switch Timing Area Form
   */
  timetableSwitchTimingAreaForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<DialogPageSwitchingTimingComponent>,
    private commonTableService: CommonTableService,
    @Inject(MAT_DIALOG_DATA) public data: DialogSwitchAreaData,
    private formBuilder: FormBuilder,
    private dialogService: DialogService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.commonTable = this.data.commonTable;
    this.timetableSwitchTimingAreaForm = this.formBuilder.group({
      seconds: [
        +this.commonTable.value,
        [Validators.required, Validators.min(Constant.VALUE_ONE), Validators.max(Constant.MAX_TIME_SECONDS)]
      ]
    });
  }

  /**
   * save
   */
  public save(): void {
    if (this.timetableSwitchTimingAreaForm.invalid) {
      return;
    }
    this.commonTable.value = this.timetableSwitchTimingAreaForm.value.seconds;
    this.commonTableService.save(this.commonTable).subscribe(
      () => {
        this.dialogRef.close(this.commonTable.value);
      },
      error => Helper.handleError(error, this.translateService, this.dialogService)
    );
  }

  /**
   * close dialog
   */
  public closeDialog(): void {
    this.dialogRef.close(undefined);
  }
}

export interface DialogSwitchAreaData {
  commonTable: CommonTable;
}
